import React from 'react';
import ReactDOM from 'react-dom';

import "assets/css/reset.css"

import App from './App';

ReactDOM.render(
    <App />,
    document.getElementById('root')
);